import { render } from "./AskResetPassword.vue?vue&type=template&id=9583a880&scoped=true&ts=true"
import script from "./AskResetPassword.vue?vue&type=script&lang=ts"
export * from "./AskResetPassword.vue?vue&type=script&lang=ts"

import "./AskResetPassword.vue?vue&type=style&index=0&id=9583a880&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/isolation/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9583a880"]])

export default __exports__